// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".key-visual-video-player-new[data-v-3e86e7a0]{width:100%;height:100%!important;-o-object-fit:cover;object-fit:cover}.key-visual-video-player-new .vjs-text-track-display[data-v-3e86e7a0]{display:none}.key-visual-video-player-new video[data-v-3e86e7a0]{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}[data-v-3e86e7a0] .vjs-big-play-button{display:none!important}", ""]);
// Exports
module.exports = exports;
